export default __webpack_public_path__ + "static/media/5_6.568e0e31.jpg";